import React from 'react';
import parse from 'html-react-parser';

interface RichTextDisplayProps {
  value?: string;
}

const RichTextDisplay: React.FC<RichTextDisplayProps> = ({ value }) => value && parse(value);

export default RichTextDisplay;
